import * as React from 'react'
import classNames from 'classnames'

import LeftQuote from 'ui-component-library/icons/quote-left-gray.svg'

import type { Image } from 'types'

import { InlineImage } from 'content-components/_Primatives/Images'
import Kicker from 'ui-component-library/components/00-Primitives/Kicker'
import Paragraph from 'content-components/_Primatives/Paragraph'
import style from './style.scss'

type Props = {
  children: React.ReactNode
  className?: string
  image?: Image
  imageSide?: 'left' | 'right'
  kicker?: string
  subject: string
  subjectTitle: string
}

function BlockQuote(props: Props) {
  const {
    className,
    image,
    imageSide = 'left',
    children,
    kicker = '',
    subject = '',
    subjectTitle = '',
  } = props
  return (
    <blockquote
      className={classNames(
        style.wrapper,
        {
          [style.imageRight]: imageSide === 'right',
          [style.imageLeft]: imageSide === 'left',
        },
        className,
      )}
    >
      {image && <InlineImage className={style.image} image={image} />}
      <div className={style.inner}>
        <div className={style.leftQuote}>
          <LeftQuote className={style.quoteIcon} />
        </div>
        {kicker && <Kicker className={style.kicker}>{kicker}</Kicker>}
        <Paragraph className={style.quote}>{children}</Paragraph>
        {subject && (
          <Paragraph small>
            <span className={style.subject}>{subject}</span>
            {subjectTitle && (
              <span className={style.subjectTitle}>, {subjectTitle}</span>
            )}
          </Paragraph>
        )}
      </div>
    </blockquote>
  )
}
export default BlockQuote
